import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ENGLISH_CULTURE, LanguageService, SWEDISH_CULTURE } from '../../../core/service/language.service';
import { MessageService } from '../../../core/service/message.service';

@Component({
    selector: 'app-send-registration-key-form-representative',
    templateUrl: './send-registration-key-form-representative.component.html',
    styleUrls: ['./send-registration-key-form-representative.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendRegistrationKeyFormRepresentativeComponent implements OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _controlModelFactory: FormControlExFactory,
    private _fb: FormBuilder,
    private _languageService: LanguageService,
    private _messageService: MessageService,
    @Inject('defaultEmail') defaultEmail: string,
    @Inject('culture') culture: string
  ) {
    if (defaultEmail) this._defaultEmail = defaultEmail;
    this._culture = culture;
  }

  private _defaultEmail: string;
  private _culture: string;
  form: FormGroup;
  languages: { name: string; value: string }[];

  cancel() {
    this._messageService.showMessage('REPRESENTATIVE.DIALOG.SEND_EMAIL_INFO');
    this._actionService.close();
  }

  ngOnInit() {
    this.languages = [
      { name: 'ENGLISH_TEXT', value: ENGLISH_CULTURE },
      { name: 'SWEDISH_TEXT', value: SWEDISH_CULTURE },
    ];
    this.form = this._fb.group({
      email: this._controlModelFactory.createEmailMandatory('SEND_REGISTRATION_KEY_FORM.EMAIL_LABEL', this._defaultEmail),
      language: this._controlModelFactory.create('LANGUAGE_TEXT', this._culture),
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.form.value.language = this._languageService.getCulture(this.form.value.language);
    this._actionService.complete(this.form.value);
  }
}
